module.exports = __webpack_public_path__ + "img/share-logo.96620bc4.png";